import { Box, Typography } from '@mui/material'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined'

const OneLineStrip = () => (
  <Box
    sx={{
      backgroundColor: '#0A9B48',
      py: 2.5,
      px: 3,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: { xs: 3, md: 8 },
        flexWrap: 'wrap',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <LocationOnOutlinedIcon sx={{ color: '#fff' }} />
        <Typography
          sx={{
            color: '#fff',
            fontWeight: 600,
          }}
        >
          Based in Basingstoke, Hampshire
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <LocalShippingOutlinedIcon sx={{ color: '#fff' }} />
        <Typography
          sx={{
            color: '#fff',
            fontWeight: 600,
          }}
        >
          Fast Delivery
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <SupportAgentOutlinedIcon sx={{ color: '#fff' }} />
        <Typography
          sx={{
            color: '#fff',
            fontWeight: 600,
          }}
        >
          Reliable Service
        </Typography>
      </Box>
    </Box>
  </Box>
)

export default OneLineStrip